"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnonymousStudentProfileUpdated = void 0;
const enumerations_1 = require("../enumerations");
class AnonymousStudentProfileUpdated {
    constructor(timestamp, state, changes, isLocal) {
        this.timestamp = timestamp;
        this.state = state;
        this.changes = changes;
        this.isLocal = isLocal;
        this.eventType = AnonymousStudentProfileUpdated.EventType;
    }
}
exports.AnonymousStudentProfileUpdated = AnonymousStudentProfileUpdated;
AnonymousStudentProfileUpdated.EventType = enumerations_1.EventType.AnonymousStudentProfileUpdated;
